// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var DebugWarning = {};
var warn = function (dictWarn) {
    return DebugWarning;
};
var traceM = function (dictDebugWarning) {
    return function (dictMonad) {
        return function (s) {
            return Control_Bind.discard(Control_Bind.discardUnit)(dictMonad.Bind1())(Control_Applicative.pure(dictMonad.Applicative0())(Data_Unit.unit))(function () {
                return $foreign.trace()(s)(function (v) {
                    return Control_Applicative.pure(dictMonad.Applicative0())(Data_Unit.unit);
                });
            });
        };
    };
};
module.exports = {
    DebugWarning: DebugWarning,
    traceM: traceM,
    warn: warn,
    trace: $foreign.trace,
    spy: $foreign.spy
};
